export enum CallRatings {
    GOOD = 'good',
    BAD = 'bad',
}

export enum DropdownTypes {
    Default = 'default',
    Text = 'text',
}

export enum JournalEmailRecipients {
    // This enum should match the enum we have in the BE (currently in journals.constants.ts)
    AgriaInjuries = 'agria-injuries',
    AgriaDirectRegulation = 'agria-direct-regulation',
}

export enum MediaType {
    VIDEO = 1,
    AUDIO = 2,
    IMAGE = 3,
}

export enum BookingActionIcons {
    VIDEOCALL = 1,
    PHONECALL = 2,
    JOURNAL = 3,
    CHECK = 4,
}

export enum BookingStatus {
    CANCELLED = 'cancel',
    FINISHED = 'finish',
    DRAFT = 'draft',
}

export enum BookingType {
    QUEUE = 'queue',
    SCHEDULED = 'scheduled',
}

export enum ServiceType {
    QUEUE = 'Queue',
    SCHEDULED = 'Scheduled',
}

export enum CallConnectionType {
    VOICE = 'voice_call',
    VIDEO = 'video_call',
}

export enum CallConnectionTypeId {
    VOICE = 1,
    VIDEO = 2,
}

export enum InsuranceStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    IN_PROGRESS = 'in_progress',
    UNKNOWN = 'unknown',
}

export enum TagColor {
    RED = 'RED',
    GREEN = 'GREEN',
    WHITE = 'WHITE',
    BLUE = 'BLUE',
    GREY = 'GREY',
    YELLOW = 'YELLOW',
}

export enum CalendarTimeSpans {
    DAY = 1,
    WEEK = 7,
}

export enum VetCategories {
    VETERINARIAN = 1,
    PRESCRIPTION = 2,
    BEHAVIOR = 4,
    BREEDER = 8,
    HEALTH_CHECK = 9,
    FEEDING = 10,
    PET_NURSE = 11,
}

export enum ItemDetailsPosition {
    RIGHT = 'RIGHT',
    LEFT = 'LEFT',
}

export enum ButtonTypes {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    SUBTLE = 'subtle',
    DESTRUCTIVE = 'destructive',
    LINK = 'link',
    ICON = 'icon',
    GO_BACK = 'back',
}

export enum KeyCodes {
    ARROW_LEFT = 37,
    ARROW_UP = 38,
    ARROW_RIGHT = 39,
    ARROW_DOWN = 40,
    TAB = 9,
    ENTER = 13,
    ESCAPE = 27,
}

export enum KeyCodeName {
    ENTER = 'Enter',
    ESCAPE = 'Escape',
    ARROW_RIGHT = 'ArrowRight',
    ARROW_LEFT = 'ArrowLeft',
}

export enum ButtonTextStyles {
    SMALL_BOLD = 'SMALL BOLD',
}

export enum AvatarSizes {
    XXSMALL = 'xxSmall',
    XSMALL = 'xSmall',
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export enum AvatarType {
    DOG = 'dog',
    CAT = 'cat',
    OTHER_ANIMAL = 'otherAnimal',
    HORSE = 'horse',
    USER = 'user',
}

export enum HttpError {
    NOT_FOUND = 404,
    UNPROCESSABLE_ENTITY = 422,
}

export enum HistoryTypes {
    JOURNAL = 'journal',
    CLINIC = 'clinic_appointment',
    REFERRAL = 'referral',
    DSS_JOURNAL = 'dss_journal',
    ERRAND_CLINIC_REFERRAL = 'errand_clinic_referral',
    INTERNAL_REFERRAL = 'internal_referral',
    MEDICAL_RECORD = 'medical_record',
}

export enum CountryCode {
    SE = 'SE',
    DK = 'DK',
    NO = 'NO',
    FI = 'FI',
    IE = 'IE',
    GB = 'GB',
    DE = 'DE',
    FR = 'FR',
}

export enum TimeZones {
    FI = 'Europe/Helsinki',
    SE = 'Europe/Stockholm',
    DK = 'Europe/Copenhagen',
    NO = 'Europe/Oslo',
    IE = 'Europe/Dublin',
    GB = 'Europe/London',
    DE = 'Europe/Berlin',
    FR = 'Europe/Paris',
}

export enum MeetingStatus {
    UPCOMING = 'upcoming',
    STARTED = 'started',
    ENDED = 'ended',
}

export enum BookingListColors {
    PRIMARY = 'primary',
    DISABLED = 'disabled',
}

export enum ErrandStatuses {
    OPEN = 'open',
    CLOSED = 'closed',
    ARCHIVED = 'archived',
}

export enum ErrandStatusId {
    OPEN = 1,
    CLOSED = 2,
    ARCHIVED = 3,
}

export enum UserRoles {
    VET = 'vet',
    ADMIN = 'admin',
    MODERATOR = 'moderator',
    ADVISOR = 'advisor',
}

export enum ErrandType {
    REFERRAL = 'internal_referral_from_app_consultation',
    COUNSELLING = 'consultation_created_by_tvk',
}

export enum MessageType {
    ANAMNESIS = 'anamnesis',
    DIAGNOSIS = 'diagnosis',
    STATUS = 'status',
    MESSAGE_TO_OWNER = 'message_to_owner',
}

export enum Currency {
    SEK = 'SEK',
    NOK = 'NOK',
    DKK = 'DKK',
    EUR = 'EUR',
}

export enum EmployeeMail {
    VETHEM = '@vethem.se',
    AGRIA_VET_GUIDE = '@agriavetguide.com',
}

export enum PaymentMethod {
    Free = 'free',
    Klarna = 'klarna',
    Insurance = 'insurance',
}

export enum VerificationType {
    Insurance = 'insurance',
    Email = 'email',
}

export enum VerificationStatus {
    Created = 'created',
    Sent = 'sent',
    Failed = 'failed',
    Verified = 'verified',
}

export enum CalendarSettingsKeys {
    Timespan = 'calendar-timespan',
    ActiveDay = 'calendar-active-day',
    SelectedVets = 'calendar-selected-vets',
    SelectedAnimalType = 'calendar-selected-animal-type',
    SelectedVetCategory = 'calendar-selected-vet-category',
}

export enum DeviceType {
    AUDIO_INPUT = 'audioinput',
    AUDIO_OUTPUT = 'audiooutput',
    VIDEO_INPUT = 'videoinput',
}

export enum ToastType {
    SUCCESS = 'success',
    SUCCESS_BOLD = 'success-bold',
    WARNING = 'warning',
    WARNING_BOLD = 'warning-bold',
    ERROR = 'error',
    ERROR_BOLD = 'error-bold',
    INFO = 'info',
    INFO_BOLD = 'info-bold',
    NETWORK_STATUS = 'network-status',
}

// TODO: remove after we have made all pages responsive
export enum Page {
    SHIFTS = 'shifts',
    ERRANDS = 'errands',
}

export enum QueueTab {
    STARTED = 0,
    COMPLETED = 1,
}

export enum QueueTabParam {
    INPROGRESS = 'inprogress',
    COMPLETED = 'completed',
}

export enum ConsultationCategoriesPayloadKeys {
    HELP_FIND_CLINIC = 'helpFindClinic',
    INSURANCE_INFO = 'insuranceInfo',
    ANIMAL_CHECKUP = 'animalCheckup',
}

export enum ConsultationCategoriesDatabaseKeys {
    HELP_FIND_CLINIC = 'help_find_clinic',
    INSURANCE_INFO = 'insurance_info',
    ANIMAL_CHECKUP = 'animal_checkup',
}

export enum RecurringShiftOption {
    EVERY_WEEK = 'EveryWeek',
    EVERY_OTHER_WEEK = 'EveryOtherWeek',
    EVERY_THIRD_WEEK = 'EveryThirdWeek',
}

export enum ModalOverflowBehavior {
    AUTO = 'auto',
    VISIBLE = 'visible',
}

export enum AnimalTypeId {
    Dog = 1,
    Cat = 2,
    Rabbit = 3,
    Bird = 4,
    Reptile = 5,
    Rodent = 6,
    Ferret = 7,
    MiniPig = 8,
    Horse = 9,
    Cattle = 10,
    Sheep = 11,
    Pig = 12,
    Goat = 13,
    Other = 14,
}

export enum ConsultationStatus {
    PENDING = 'Pending',
    IN_PROGRESS = 'InProgress',
    COMPLETED = 'Completed',
}
export enum IconSize {
    XS = 'XS',
    S = 'S',
    M = 'M',
    L = 'L',
    XL = 'XL',
    XXL = 'XXL',
    XXXL = 'XXXL',
}

export enum ConsultationPriority {
    URGENT = 'Urgent',
    NORMAL = 'Normal',
}

export enum Order {
    ASC = 'asc',
    DESC = 'desc',
}

export enum SortBy {
    QUEUE = 'queueOrder',
    CREATED_AT = 'createdAt',
}

export enum Source {
    PORTAL = 'portal',
}
